<nb-card>
  <nb-card-header>
    <button
      class="cancel"
      nbButton
      ghost
      status="info"
      size="small"
      (click)="cancel()"
    >
      <nb-icon icon="close-outline"></nb-icon>
    </button>

    <h6 id="title" class="title">Đăng nhập</h6>
    <p class="sub-title">Xin chào, đã quay trở lại Learning.</p>
  </nb-card-header>

  <nb-card-body>
    <nb-alert
      *ngIf="showMessages.error && errors?.length && !submitted"
      outline="danger"
      role="alert"
    >
      <p class="alert-title"><b>Lỗi rồi!</b></p>
      <ul class="alert-message-list">
        <li *ngFor="let error of errors" class="alert-message">{{ error }}</li>
      </ul>
    </nb-alert>

    <nb-alert
      *ngIf="showMessages.success && messages?.length && !submitted"
      outline="success"
      role="alert"
    >
      <p class="alert-title"><b>Hooray!</b></p>
      <ul class="alert-message-list">
        <li *ngFor="let message of messages" class="alert-message">
          {{ message }}
        </li>
      </ul>
    </nb-alert>

    <div [formGroup]="loginForm" aria-labelledby="title">
      <div class="form-control-group">
        <label for="input-email">Email:</label>
        <input
          nbInput
          fullWidth
          id="input-email"
          formControlName="email"
          [status]="email.dirty ? (email.invalid ? 'danger' : 'success') : ''"
          [attr.aria-invalid]="email.invalid && email.touched ? true : null"
          placeholder="Email address"
        />
        <ngx-validation-message
          label="Email address"
          [showPattern]="email?.hasError('pattern') && email.touched"
          [showRequired]="email?.errors?.required && email.touched"
        ></ngx-validation-message>
      </div>

      <div class="form-control-group">
        <span class="label-with-link">
          <label class="label" for="input-password">Password:</label>
          <a class="forgot-password caption-2" href="auth/request-password"
            >Quên mật khẩu?</a
          >
        </span>
        <input
          nbInput
          fullWidth
          id="input-password"
          formControlName="password"
          type="password"
          [status]="
            password.dirty ? (password.invalid ? 'danger' : 'success') : ''
          "
          placeholder="Password"
        />
        <ngx-validation-message
          label="Password"
          [showMinLength]="password?.hasError('minlength') && password.touched"
          [showMaxLength]="password?.hasError('maxlength') && password.touched"
          [showRequired]="password?.errors?.required && password.touched"
          [minLength]="minLength"
          [maxLength]="maxLength"
        ></ngx-validation-message>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <button
      nbButton
      fullWidth
      status="primary"
      size="small"
      (click)="login()"
      [disabled]="submitted || !loginForm.valid"
      [class.btn-pulse]="submitted"
    >
      Đăng nhập
    </button>

    <section class="another-action" aria-label="Register">
      Chưa có tài khoản?
      <a class="text-link" href="/auth/register">Đăng Ký</a>
    </section>
  </nb-card-footer>
</nb-card>
